import { render } from "./AnalyticsView.vue?vue&type=template&id=4876b508"
import script from "./AnalyticsView.vue?vue&type=script&lang=js"
export * from "./AnalyticsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__